import "./App.css";
import "./index.css";
import Home from "./Component/Home";
import LiquidDropLogin from "./Component/LiquidDropLogin";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Cookies from "js-cookie";
import Main from "./Component/Main";
import Users from "./Component/Users";
import Emails from "./Component/Emails";
import Proxy from "./Component/Proxy";
import Files from "./Component/Files";
import Whitelist from "./Component/Whitelist";
import UserFile from "./Component/UserFile";
import { OfficialSiteLayout } from "./Component/OfficialSiteLayout"; 
import { LandingPage } from "./pages/LandingPage";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfService } from "./pages/TermsOfService";
import { CookiePolicy } from "./pages/CookiePolicy";

// 创建一个受保护的路由组件
const ProtectedRoute = ({ children }) => {
  // 使用cookie检查登录状态
  const isAuthenticated = !!Cookies.get("token");

  if (!isAuthenticated) {
    // 如果未登录，重定向到登录页面
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  const hostname = window.location.hostname;
  const isOfficialSite = hostname === "www.hsmail.vip";
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

  return (
    <Router>
      <Routes>
        {/* Case 1: Strictly Official Site (www.hsmail.vip) - Only Landing Pages */}
        {isOfficialSite && (
          <>
            <Route element={<OfficialSiteLayout />}>
              <Route index element={<LandingPage />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="terms-of-service" element={<TermsOfService />} />
              <Route path="cookie-policy" element={<CookiePolicy />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}

        {/* Case 2: Localhost - Hybrid (Landing Pages + Dashboard) */}
        {isLocal && (
          <>
            {/* Landing Pages */}
            <Route element={<OfficialSiteLayout />}>
              <Route index element={<LandingPage />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="terms-of-service" element={<TermsOfService />} />
              <Route path="cookie-policy" element={<CookiePolicy />} />
            </Route>

            {/* Dashboard Routes */}
            <Route path="/login" element={<LiquidDropLogin />} />
            <Route
              path="/Home"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/Home/main" replace />} />
              <Route path="main" element={<Main />} />
              <Route path="users" element={<Users />} />
              <Route path="emails" element={<Emails />} />
              <Route path="proxy" element={<Proxy />} />
              <Route path="files" element={<Files />} />
              <Route path="whitelist" element={<Whitelist />} />
              <Route path="userFiles" element={<UserFile />} />
            </Route>
            
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}

        {/* Case 3: Dashboard Domain (dashboard.hsmail.vip or others) - Only Dashboard */}
        {!isOfficialSite && !isLocal && (
          <>
            <Route path="/login" element={<LiquidDropLogin />} />
            <Route
              path="/Home"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/Home/main" replace />} />
              <Route path="main" element={<Main />} />
              <Route path="users" element={<Users />} />
              <Route path="emails" element={<Emails />} />
              <Route path="proxy" element={<Proxy />} />
              <Route path="files" element={<Files />} />
              <Route path="whitelist" element={<Whitelist />} />
              <Route path="userFiles" element={<UserFile />} />
            </Route>

            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
